import React, { useRef, useEffect } from 'react'
import '@google/model-viewer'

export default function LightboxModelViewer({ src, iosSrc, style }) {
  const ref = useRef()

  useEffect(() => {
    if (!ref.current) return
    ref.current.setAttribute('src', src)
    if (iosSrc) ref.current.setAttribute('ios-src', iosSrc)
    ref.current.setAttribute('camera-controls', '')
    ref.current.setAttribute('ar', '')
    ref.current.setAttribute('touch-action', 'pan-y')
    ref.current.setAttribute('shadow-intensity', '1.5')
  }, [src, iosSrc])

  return <model-viewer ref={ref} style={style}></model-viewer>
}
